import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

const links = [
  { label: "About", href: "#about" },
  { label: "Teams", href: "#teams" },
  { label: "Schedule", href: "#schedule" },
  { label: "Rules", href: "#rules" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src="https://customer-assets.emergentagent.com/job_adult-baseball-hub/artifacts/b8ws7h83_wabl%20logo.jpg"
            alt="WABL logo"
            className="h-12 w-12 object-contain"
          />
          <span className="font-heading text-2xl tracking-tight hidden sm:block">WABL</span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-bold uppercase tracking-[0.15em] text-[#8A94A0] hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#signup"
            data-testid="nav-signup-cta"
            className="font-heading uppercase tracking-wide bg-[#FF3B30] text-white hover:bg-[#FF6B63] hover:-translate-y-0.5 transition-all px-6 py-3 text-sm"
          >
            Sign Up
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden bg-[#0A0A0A] border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-bold uppercase tracking-[0.15em] text-[#8A94A0] hover:text-white"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#signup"
            onClick={() => setOpen(false)}
            className="font-heading uppercase bg-[#FF3B30] text-white px-6 py-3 text-center"
          >
            Sign Up
          </a>
        </div>
      )}
    </nav>
  );
};
